import { ChargeEventStatusForAPI } from './ChargeEventStatus'

export const TransactionTableDefaults = {
    START_PAGE: 0,
    NUMBER_OF_RECORDS: 20,
    STATUS: `${ChargeEventStatusForAPI.PAID},${ChargeEventStatusForAPI.REFUNDED},${ChargeEventStatusForAPI.PARTIALLY_REFUNDED}`,
}
